<template>
  <div
    class="ciae-rms-wrap"
    v-loading="loading.value"
    :element-loading-text="loading.text"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="musicbox-header">
      <span class="state">设备数量: {{ online }}</span>
      <span class="title" @dblclick="screenfullToggle">CIAE-RMS首页</span>
      <span class="handler">
        <span v-if="showOpenWindowButton" class="iconfont icon-dakai" @click="openNewWindow"></span>
      </span>
    </div>
    <div class="musicbox-content-wrap">
      <div class="musicbox-content scrollbar-thin">
        <el-row
          :gutter="20"
          type="flex"
          justify="flex-start"
          v-for="(list, index) in deviceGroup"
          :key="`group-${index}`"
        >
          <el-col v-for="device in list" :key="device.sn" :xs="12" :sm="8" :md="8" :lg="6" :xl="4">
            <InfoBox :sn="device.sn" :name="device.name" :data="deviceDataMap[device.sn]" />
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import InfoBox from './components/info-box.vue';
import { windowOpen, getResolutionSymbol } from '@/utils/utils';
import screenfull from 'screenfull';
import { mapMutations, mapState, mapActions } from 'vuex';
import Type from '@/store/mutation-type';
import ctt from '@/utils/const';

export default {
  components: {
    InfoBox
  },
  sockets: {
    '/socket/detail'(res) {
      this.subDevice(res);
      this.updateData(res);
    }
  },
  data() {
    return {
      visible: false,
      activeSn: '',
      snList: [],
      deviceList: [],
      deviceDataMap: {},
      loading: {
        value: false,
        text: '设备连接中, 请耐心等待'
      }
    };
  },
  computed: {
    ...mapState('socket', ['devicesSourseMap']),
    showOpenWindowButton() {
      return !window.name;
    },
    online() {
      const total = this.snList.length;
      const online = this.deviceList.filter(e => e.runstate > 0).length;
      return `${online}/${total}`;
    },
    deviceGroup() {
      const group = [];
      const size = getResolutionSymbol();
      const config = { xs: 2, sm: 3, md: 3, lg: 4, xl: 6 };
      const limit = config[size];
      const len = this.deviceList.length;
      const count = Math.ceil(len / limit);
      for (let index = 0; index < count; index++) {
        group.push(this.deviceList.slice(index * limit, (index + 1) * limit));
      }
      return group;
    }
  },
  methods: {
    ...mapMutations('socket', {
      subDevice: Type.SUB_DEVICE
    }),
    ...mapActions('mqtt', ['subDeviceDetail', 'unsubDeviceDetail']),
    openNewWindow() {
      windowOpen(this.$route, this.$route.name);
    },
    screenfullToggle() {
      if (screenfull.isFullscreen) {
        screenfull.exit();
      } else {
        screenfull.request(document.getElementById('appContent'));
      }
    },
    showLoading() {
      this.loading.value = true;
    },
    hideLoading() {
      if (!this.loading) return;
      setTimeout(() => {
        this.loading.value = false;
      }, 200);
    },
    subscribeDetail() {
      if (!this.snList.length) return;
      this.subDeviceDetail({ sn: this.snList });
      // this.$socket.emit('/socket/detail', this.snList.join(','));
    },
    unsubscribeDetail() {
      if (!this.snList.length) return;
      this.unsubDeviceDetail({ sn: this.snList });
      // this.$socket.emit('/socket/unsubscribe/detail', this.snList.join(','));
    },
    updateData(res) {
      if (!this.snList.includes(res.sn)) return;
      this.$set(this.deviceDataMap, res.sn, res);
    },
    initData() {
      this.devicesSourseMap.forEach(device => {
        if (device.deviceType !== ctt.CIAE_RMS_E && device.deviceType !== ctt.CIAE_RMS_C) return;
        this.deviceList.push(device);
      });
      this.snList = this.deviceList.map(e => e.sn);
    }
  },
  created() {
    this.initData();
    this.subscribeDetail();
  },
  beforeDestroy() {
    this.unsubscribeDetail();
    this.hideLoading();
  }
};
</script>

<style lang="scss">
.ciae-rms-wrap {
  height: 100%;
  display: flex;
  flex-direction: column;
  .musicbox-header {
    color: $primary-text-color;
    margin-bottom: 15px;
    background: url('/static/image/main_header.png');
    height: 60px;
    background-size: 100% 100%;
    position: relative;
    text-align: center;
    user-select: none;

    .title {
      font-size: 28px;
      font-weight: bold;
    }
    .state {
      position: absolute;
      font-size: 16px;
      left: 5px;
      top: 8px;
    }
    .handler {
      position: absolute;
      right: 15px;
      top: 5px;
      .icon-dakai {
        font-size: 20px;
        cursor: pointer;
      }
    }
  }

  .musicbox-content-wrap {
    overflow: hidden;
    height: calc(100% - 60px);
    .musicbox-content {
      height: 100%;
      overflow-y: scroll;
      overflow-x: hidden;

      padding: 5px;

      .el-row {
        margin-bottom: 15px;
      }
    }
  }
}
</style>
